// Deal type interface
// Note: Array fields (team, people, advisors, vendors) come as actual arrays from both APIs
export interface DealData {
  dealId: string;
  dealName: string;
  portfolioCompanyName?: string;
  year?: string | number;
  stage?: string;
  team?: string[]; // Array of team names e.g. ["SE Asia"]
  sector?: string;
  country?: string;
  description?: string;
  business?: string;
  fund?: string;
  companyOverview?: string;
  company_overview?: string;
  COMPANY_OVERVIEW?: string;
  inclusionRationale?: string;
  isPublished?: boolean;
  isSensitive?: boolean;
  // New fields from API
  investmentYear?: number;
  dealStage?: string;
  sensitivity?: string;
  dealType?: string;
  closingDate?: string | null;
  exitYear?: number | null;
  lastIcStage?: string | null;
  // EV/EBITDA Multiple fields
  entryEvEbitdaLtmActual?: number | null;
  entryEvEbitdaLtmBudget?: number | null;
  entryEvEbitdaLtmForecast?: number | null;
  exitEvEbitdaActual?: number | null;
  exitEvEbitdaBudget?: number | null;
  exitEvEbitdaForecast?: number | null;
  // Array fields
  vendor?: string[] | null; // Array of vendor names
  vendors?: string[] | null; // Array of vendor names
  people?: string[] | null; // Array of people names with roles
  teamMembers?: string[] | null; // Array of team member names
  advisors?: string[] | null; // Array of advisor names with roles
  deadReason?: string | null;
  // eFront lifecycle & contact fields
  dead?: string | null;
  lastActiveStatus?: string | null;
  exitCompleted?: string | null;
  efrontIoContact1?: string | null;
  efrontIoContact2?: string | null;
  documents?: unknown[] | null;
  documentCount?: number;
}

// Document type interface
export interface DocumentData {
  docId: string;
  dealId?: string;
  documentName?: string;
  originalFilename?: string;
  summaryText?: string;
  documentCategory?: string;
  mimeType?: string;
  fileSize?: number;
  processingStatus?: string;
  createdAt?: string;
  updatedAt?: string;
  documentOrigin?: string;
  filePath?: string;
  sharepointSiteId?: string;
  sharepointDriveId?: string;
  sharepointItemId?: string;
}

/** Shape the preview panel expects — `filename` mirrors the document name. */
export function toPreviewDocument(document: DocumentData): Record<string, unknown> {
  return {
    originalFilename: document.originalFilename,
    docId: document.docId,
    filename: document.documentName,
    summaryText: document.summaryText,
    documentCategory: document.documentCategory,
    mimeType: document.mimeType,
    fileSize: document.fileSize,
    processingStatus: document.processingStatus,
    createdAt: document.createdAt,
    updatedAt: document.updatedAt,
    documentOrigin: document.documentOrigin,
    filePath: document.filePath,
    sharepointSiteId: document.sharepointSiteId,
    sharepointDriveId: document.sharepointDriveId,
    sharepointItemId: document.sharepointItemId,
  };
}
